<template>
  <!-- MOBILE SIDEBAR MENU -->
  <section class="aside_snb_mobile">
    <div class="side_inner">
      <div class="logo_cancel">
        <div class="logo_box">
          <img src="@/assets/images/hakji_web_logo.png" alt="로고" />
        </div>
        <button class="cancel" @click="$emit('close')">
          <img src="@/assets/images/mobile_main/cancel.png" alt="닫기" />
        </button>
      </div>
      <div class="person_info">
        <a v-if="!getCurrentUser" class="member" @click="login">
          <span>로그인</span>
        </a>
        <a v-if="getCurrentUser" href="/account" class="member">
          <span>{{ getCurrentUser.memberNm }} 님</span>
          <img src="@/assets/images/mobile_main/setting.png" alt="설정" />
        </a>
        <a href="/library" class="my_lib">
          내 서재 가기
        </a>
      </div>
      <div
        v-if="getCurrentUser && getCurrentUser.memberTp === '2000'"
        class="teacher_only"
      >
        <a href="/help/present/post">교강사 증정코드 입력</a>
      </div>
      <!-- <div class="event_info">
        <span class="topic">이벤트(신학기 도서할인)</span>
        <div class="event_box">
          <a href="/store/books/event/1">
            <span>이벤트 도서</span>
            <span>8권</span>
          </a>
        </div>
      </div> -->
      <article class="catagory_wrap">
        <span class="cata_title">도서 카테고리</span>
        <ul class="cata_list">
          <li
            v-for="(catgry, i) in getCatgryList"
            v-show="i > 0"
            :key="i + 'catgry'"
            :class="{
              active: activeSubTab === catgry.catgryCd
            }"
            @click="moveCategory(catgry)"
          >
            <a
              :href="'/store/' + catgry.catgryCd + '/books/' + catgry.catgryCd"
            >
              <span class="snb_list">{{ catgry.catgryNm }}</span>
              <span>{{ catgry.childCnt }} 권</span>
            </a>
          </li>
        </ul>
      </article>
    </div>
    <transition name="modal-fade">
      <CreateNewModal v-if="showNewModal" @close="closeNewModal" />
    </transition>
    <!-- // NEW LIST MODAL -->

    <!-- NEW LIST MODAL -->
    <transition name="modal-fade">
      <EditModal
        v-if="showEditModal"
        :bookshelf="currentEditBookshelf"
        @close="closeEditModal"
      />
    </transition>
    <!-- // NEW LIST MODAL -->

    <!-- DELETE MODAL -->
    <transition name="modal-fade">
      <DeleteModal
        v-if="showDeleteModal"
        :bookshelf="currentDeleteBookshelf"
        @close="closeDeleteModal"
      />
    </transition>
    <!-- END DELETE MODAL -->
  </section>
</template>

<script>
//import ListItem from '@/components/library/ListItem'
import CreateNewModal from '@/components/library/CreateNewModal.vue'
import EditModal from '@/components/library/EditModal.vue'
import DeleteModal from '@/components/library/DeleteModal.vue'

import isHideEnote from '@/store/constants.js'

import { mapGetters } from 'vuex'
import {
  BOOKSHELF_GET_LIST,
  UI_CLOSE_SIDEBAR,
  AUTH_LOGOUT,
  STORE_CATEGORIES_GET_LIST
} from '@/store/types'

export default {
  name: 'MobileSidebar',
  components: {
    //ListItem,
    CreateNewModal,
    EditModal,
    DeleteModal
  },
  data() {
    return {
      isHideEnote,
      activetab: '',
      activeSubTab: '',
      showNewModal: false,
      showEditModal: false,
      showDeleteModal: false,
      currentEditBookshelf: null,
      currentDeleteBookshelf: null
    }
  },
  computed: {
    // ...mapGetters(['getMainCategories']),
    getCatgryList() {
      return this.getMainCategories || []
    },
    ...mapGetters([
      'isAuthLoading',
      'getCurrentUser',
      'getMainCategories',
      'getBookshelves',
      'getBookshelfCount',
      'isBookshelfLoading',
      'getMainEventCategories'
    ]),
    emptyBookshelf() {
      const empty = {
        bookshelfId: '',
        bookshelfNm: '전체도서',
        bookshelfTp: '',
        id: '',
        isDefault: false,
        name: '전체도서'
      }
      return empty
    },
    staticBookshelves() {
      return this.getBookshelves.filter(
        (e) => e.bookshelfTp !== 'UBS' && e.bookshelfTp !== 'DBS'
      )
    },
    baseBookshelves() {
      return this.getBookshelves.filter(
        (e) =>
          e.bookshelfTp !== 'GFT' &&
          e.bookshelfTp !== 'PRS' &&
          e.bookshelfTp !== 'CPN'
      )
    },
    hasEventBook() {
      if (this.getMainEventCategories?.count > 0) {
        return true
      }
      return false
    }
  },
  beforeMount() {
    if (this.getCurrentUser) {
      if (!this.getBookshelves.length) {
        this.$store.dispatch(BOOKSHELF_GET_LIST)
      }
    }
    if (!this.getMainCategories) {
      this.$store.dispatch(STORE_CATEGORIES_GET_LIST)
    }
  },
  mounted() {
    switch (this.$route.name) {
      case 'books_category':
        this.activetab = 'campus'
        this.activeSubTab = this.$route.params.category || ''
        break
      case 'category_books':
        this.activetab = 'category'
        this.activeSubTab = this.$route.params.category || ''
        break
      case 'postPresent':
      case 'present':
        this.activetab = 'teacher'
        this.activeSubTab = this.$route.name || ''
        break
      case 'library':
        this.activetab = 'library'
        this.activeSubTab = this.$route.params.id || ''
        break
      default:
        this.activetab = ''
        break
    }
  },
  methods: {
    moveCategory(catgry) {
      this.activeSubTab = catgry.catgryCd
      if (catgry.catgryCd == 'A' || !catgry.subCatgryList.length) {
        this.$router.push({
          name: 'category_books',
          params: {
            category: catgry.catgryCd,
            subCategory: catgry.catgryCd
          }
        })
        this.$emit('close')
      } else {
        return
      }
    },
    moveSubCategory(catgry, subctgry) {
      this.$router.push({
        name: 'category_books',
        params: {
          category: 'null',
          subCategory: 'null',
          subCategoryNm: 'null'
        }
      })
      this.$router.push({
        name: 'category_books',
        params: {
          category: catgry.catgryCd,
          subCategory: subctgry.subCatgryCd,
          subCategoryNm: subctgry.subCatgryNm
        }
      })
      this.$emit('close')
      //같은 ctgry에서는 처음 보낸 값으로만 push됨->왜지?
      // console.log(this.$route.params.category)
      // console.log(this.$route.params.subCategory)
      // console.log(this.$route.params.subCategoryNm)
    },
    // SIDEBAR
    closeSidebar() {
      this.$store.commit(UI_CLOSE_SIDEBAR)
    },
    closeEditMenu() {
      this.$emit('closeEditMenu')
    },
    // MODAL METHODS
    openNewModal() {
      this.showNewModal = true
    },
    closeNewModal() {
      this.showNewModal = false
    },
    openEditModal(bookshelf) {
      this.currentEditBookshelf = bookshelf
      this.showEditModal = true
    },
    closeEditModal() {
      this.currentEditBookshelf = null
      this.showEditModal = false
    },
    openDeleteModal(bookshelf) {
      this.currentDeleteBookshelf = bookshelf
      this.showDeleteModal = true
    },
    closeDeleteModal() {
      this.currentDeleteBookshelf = null
      this.showDeleteModal = false
    },
    async logout() {
      await this.$store.dispatch(AUTH_LOGOUT)
      this.$emit('close')
      // this.$store.reset()
      this.$router.go(this.$route.currentRoute)
    },
    login() {
      this.$emit('close')
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style lang="scss" scoped>
.util_wrap {
  margin-right: 22px !important;
}

.btn_close_snb {
  margin-right: 10px !important;
}

.aside_snb_mobile .snb_menu_tit {
  cursor: pointer;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  padding-top: 22px !important;
  padding-bottom: 22px;
}

.active-padding {
  padding-bottom: 0px !important;
}

.aside_snb_mobile .snb_menu.s_m_etc .snb_sub > li.active:after {
  top: 12px;
  right: 35px;
}
.aside_snb_mobile {
  overflow-y: auto;
}
.categroy_wrap > li {
  margin-left: 16px;
}

//2022. 05. 17 추가 개발
.aside_snb_mobile .snb_box {
  padding: 22px 0px 24px 30px;
}
.aside_snb_mobile .snb_box .snb_sub > li {
  cursor: pointer;
}
.aside_snb_mobile .snb_box .snb_sub > li .snb_list {
  // padding: 6px 24px;
}
.aside_snb_mobile .snb_box .snb_sub > li.active {
  background-color: #36a5c2;
}
.aside_snb_mobile .snb_menu.s_m_etc .snb_sub > li.active:after {
  display: none;
}
.ctg_sub_wrap {
  display: none;
}
.aside_snb_mobile .snb_box .snb_sub > li .ctg_sub_wrap .snb_sub_list {
  color: #000;
  background-color: #f7f7f7;
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  font-size: 15px;
  font-weight: 500;
  line-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: normal;
  padding: 6px 38px;
}
.aside_snb_mobile .snb_box .snb_sub > li .ctg_sub_wrap {
  margin: 8px 0;
}
.aside_snb_mobile .snb_box .snb_sub > li .ctg_sub_wrap li {
  margin-top: 2px;
}
.aside_snb_mobile .snb_box .snb_sub > li.active .ctg_sub_wrap {
  display: block;
}
.snb_menu_area::-webkit-scrollbar {
  display: none;
}

// 2022. 05. 30 추가 개발
.aside_snb_mobile .snb_user .btn_login {
  position: absolute;
  display: inline-block;
  width: 75px;
  height: 32px;
  text-align: center;
  border: 1px solid #d5dff3;
  border-radius: 3px;
}
.aside_snb_mobile .snb_user .btn_login .an_t {
  font-size: 14px;
  font-weight: 500;
  line-height: 29px;
  color: #778899;
}

// 2024. 01. 24 추가
.snb_event_area {
  width: 100%;
  height: 60px;
  padding: 20px;
  color: #0f638f;
  background-color: greenyellow;
  border-bottom: 1px solid #e6ebf5;
  font-size: 16px;
  .snb_event {
    display: block;
    height: inherit;
  }
}
.snb_menu.s_m_library .snb_menu_tit {
  color: #125c83;
  padding-bottom: 22px !important;
}

// 리뉴얼
.side_inner {
  padding: 15px 25px;
}
.logo_cancel {
  display: flex;
  justify-content: space-between;
}
.logo_box {
  width: 160px;
  height: 31px;
  img {
    width: 100%;
    height: 100%;
  }
}
.cancel {
  width: 36px;
  height: 36px;
  img {
    width: 100%;
    height: 100%;
  }
}
.person_info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 13px;
  margin-top: 20px;
  > a {
    flex: 0.5;
    height: 70px;
    background-color: #f2f5f8;
    border-radius: 50px;
    font-weight: 600;
    font-size: 19px;
    &.member {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 40px;
      img {
        width: 27px;
        height: 27px;
      }
    }
    &.my_lib {
      text-align: center;
      line-height: 70px;
    }
  }
}
.teacher_only {
  background-color: #f2f5f8;
  border-radius: 10px;
  margin-top: 14px;
  > a {
    display: flex;
    justify-content: space-between;
    padding: 30px 30px;
    line-height: 19px;
    font-weight: 600;
    font-size: 19px;
    text-align: center;
    &::after {
      content: '>';
      color: #778899;
    }
  }
}
.event_info {
  margin-top: 30px;
  .topic {
    font-size: 19px;
    font-weight: 600;
  }
  .event_box {
    margin-top: 15px;
    a {
      display: flex;
      justify-content: space-between;
      padding: 30px 30px;
      background-color: #f2f5f8;
      border-radius: 10px;
      line-height: 19px;
      span {
        font-weight: 600;
        &:first-child {
          font-size: 19px;
        }
        &:last-child {
          font-size: 17px;
          color: #778899;
        }
      }
    }
  }
}
.catagory_wrap {
  margin-top: 30px;
  .cata_title {
    font-size: 19px;
    font-weight: 600;
  }
  .cata_list {
    margin-top: 15px;
    li {
      background-color: #f2f5f8;
      margin-bottom: 14px;
      border-radius: 10px;
      > a {
        display: flex;
        justify-content: space-between;
        padding: 30px 30px;
        line-height: 19px;
      }
      span {
        font-weight: 600;
        &:first-child {
          font-size: 19px;
        }
        &:last-child {
          font-size: 17px;
          color: #778899;
        }
      }
    }
  }
}
</style>
